// extracted by mini-css-extract-plugin
export default {"containerList":"BloccoDocenze_containerList__E564U"};